import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPvs, getFavoritos, getPedidos, salvaFavoritos } from '../../../services/APIService';
import 'react-virtualized/styles.css'; // only needs to be imported once

import { getUserData } from '../../../utils/Services';
//getUserAuthorization

import { lightFormat, isEqual, isBefore, isAfter, parseISO } from 'date-fns';
import { ordenarPorAlfabetica } from '../../../utils/Functions';
/**
 *
 * COMPONENTS
 *
 * */
import CardFaccaoBasic from '../../../components/CardFaccaoBasic';
import ModalConfirmation from './Modal';

import { bindActionCreators } from 'redux';
import {
    addPedidos,
    clearPedidos,
    addCapacidades,
    setDiasSemana,
    setPVs,
    setPVsPedidos,
    setPvAtual,
    setDiasUteis,
    setDiasUteisAtual,
    showSuccess,
    showError,
    showLoading,
    hideLoading,
    setCurrentDataPV,
    clearCurrentDataPv,
    addLoad,
    setIsHome,
} from '../../../actions';

import AddFaccaoModal from '../../AdicionarFaccoes/form';
const malha = 1;

export class Home extends Component {
    state = {
        dataOptions: [],
        selectedData: [],
        confirmRemove: false,
        favoritos: [],
        faccao: {},
        openModal: false,
        pvs: [],
        showFaccoesModal: false,
    };

    componentDidMount() {
        this.props.setIsHome();
        this._carregaPvAtual();
        this._carregaFavoritos();
    }

    _carregaPvAtual = async () => {
        this.props.clearCurrentDataPv();
        const date = lightFormat(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        let pvs = await getPvs(date, malha);
        pvs = pvs.ET_PERIODOS;

        // SETA TODOS OS PVS A PARTIR DA DATA ATUAL
        let newPvs = [];
        pvs && pvs.map(e => newPvs.push(e.PERPLAN));
        this.props.setPVs(newPvs);

        // SETA PV ATUAL
        const pvAtual =
            pvs &&
            pvs.filter(e => {
                let dataInicio = parseISO(e.PPVON);
                let dataFim = parseISO(e.PPBIS);
                let dataAtual = parseISO(date);
                // Verifica se data de inicio é anterior a data setada e se a data de fim é posterior a data setada
                if (isBefore(dataAtual, dataFim) && isAfter(dataAtual, dataInicio)) return true;
                // Verifica se data de inicio ou fim da pv é igual a data setada
                else if (isEqual(dataAtual, dataInicio) || isEqual(dataAtual, dataFim)) return true;
                else return false;
            });

        //pvAtual && this.props.setCurrentDataPV([pvAtual[0].PERPLAN]);
        //pvAtual && this.props.setPvAtual(pvAtual[0].PERPLAN);
    };

    _carregaFavoritos = async () => {
        this.props.showLoading();
        let favoritos = [];
        try {
            const res = await getFavoritos(getUserData().login);
            if (res.data.length > 0) {
                favoritos = res.data;
                localStorage.setItem('favoritos', JSON.stringify(res.data));
            }
        } catch (e) {
            this.props.hideLoading();
            // this.props.showError('Não foi possível carregar favoritos');
        }

        if (favoritos.length > 0) {
            const date = lightFormat(
                process.env.REACT_APP_DATE_PV ? parseISO(process.env.REACT_APP_DATE_PV) : parseISO(new Date().toISOString()),
                'yyyy-MM-dd'
            );
            const favs = favoritos.map(e => {
                return {
                    LIFNR: e.value,
                };
            });

            //const today = new Date().getDate();
            //const savedDate = new Date(this.props.loadState.date).getDate();

            // Carrega pedidos por favoritos
            try {
                let res;
                res = await getPedidos({
                    VERSAO: 'V3',
                    I_DATA: date,
                    I_T_LIFNR: [...favs],
                    I_ID_PROCESSO: malha,
                });

                this.props.addLoad(new Date());
                this.props.addPedidos(res.ET_PEDIDOS);
                //}
            } catch (e) {
                console.log(e);
                this.props.hideLoading();
                // this.props.showError('Erro ao carregar pedidos dos favoritos');
            }
        }
        this.props.hideLoading();
        this._setaPvs();
        this.setState(state => (state.selectedData = favoritos));
    };

    _setaPvs = () => {
        let Pvs = [];
        let pvAtual = [];
        this.props.pedidos.length > 0 &&
            this.props.pedidos.map(e => {
                if (!Pvs.includes(e.PERPLAN)) {
                    Pvs.push(e.PERPLAN);
                }
                return false;
            });

        pvAtual.push(Pvs[0]);
        this.props.setCurrentDataPV(pvAtual);
        this.props.setPvAtual(pvAtual);
        this.props.setPVsPedidos(Pvs);
        this.setState(state => (state.pvs = Pvs));
    };

    _salvaNovosFavoritos = async data => {
        this.props.showLoading();
        await salvaFavoritos(getUserData().login, data);
        await this._carregaFavoritos();
        this.props.hideLoading();
    };

    _removeFavorito = codigo => {
        this.setState(state => {
            const index = state.selectedData.findIndex(e => e.value === codigo);
            if (index >= 0 && this.state.selectedData.length > 1) {
                state.selectedData.splice(index, 1);
                this.props.showLoading();
                this._salvaNovosFavoritos(state.selectedData);
                this.props.hideLoading();
                return (state.selectedData = [...state.selectedData]);
            } else if (index >= 0) {
                this.props.showLoading();
                this._salvaNovosFavoritos([]);
                this.props.hideLoading();
                return (state.selectedData = []);
            }
        });
    };

    _setFaccao = e => {
        this.setState(state => {
            state.faccao = {
                nome: e.label,
                codigo: e.value,
            };
        });
    };

    _handleSelectChange = value => {
        if (value && this.state.selectedData && value.length > this.state.selectedData.length) {
            this._salvaNovosFavoritos(value);
            this.setState(state => (state.selectedData = value));
        } else if (
            (this.state.selectedData && value && this.state.selectedData.length > 0 && this.state.selectedData.length > value.length) ||
            (this.state.selectedData && this.state.selectedData.length > 0 && !value)
        ) {
            if (this.state.selectedData.length > 1) {
                this.state.selectedData.forEach(e => {
                    if (value && value.length > 0 && value.indexOf(e) === -1) {
                        this._setFaccao(e);
                        this._toggleModal();
                    }
                });
            } else {
                this._setFaccao(this.state.selectedData[0]);
                this._toggleModal();
            }
        } else {
            this._salvaNovosFavoritos(value);
            return value;
        }
    };

    _toggleModal = (value, label) => {
        this.setState(state => (state.faccao = { value, label }));
        this.setState(state => (state.openModal = !this.state.openModal));
    };

    _closeConfirmationModal = () => {
        this.setState(state => (state.openModal = !this.state.openModal));
    };

    _toggleCalculaSoma = () => {
        this.setState(state => (state.calculaSoma = false));
    };

    closeModal = () => {
        this.setState(state => (state.showFaccoesModal = false));
    };

    showModal = () => {
        this.setState(state => (state.showFaccoesModal = true));
    };

    render() {
        return (
            <React.Fragment>
                <button
                    className='btn btn-primary d-flex align-items-center justify-content-center'
                    style={{
                        position: 'fixed',
                        bottom: '15px',
                        right: '15px',
                        zIndex: 1,
                        width: 55,
                        height: 55,
                        borderRadius: 55,
                    }}
                    onClick={this.showModal}
                >
                    <i className='fa fa-plus' style={{ fontSize: '1.5em' }}></i>
                </button>
                <div className='col-sm-12 m-0 px-2 justify-content-center'>
                    <div className='row m-0 py-0 w-100'>
                        {this.state.selectedData &&
                            this.state.selectedData
                                .sort((a, b) => ordenarPorAlfabetica(a.label, b.label))
                                .map(f => {
                                    return (
                                        <CardFaccaoBasic
                                            codigo={f.value}
                                            nome={f.label}
                                            key={f.value}
                                            toggleModal={this._toggleModal}
                                        ></CardFaccaoBasic>
                                    );
                                })}
                    </div>
                </div>
                {this.state.openModal && (
                    <ModalConfirmation
                        faccao={this.state.faccao}
                        isOpen={this.state.openModal}
                        toggle={this._closeConfirmationModal}
                        removeFavorito={this._removeFavorito}
                        carregarFavoritos={this._carregaFavoritos}
                        clearPedidos={this.props.clearPedidos}
                    />
                )}

                <AddFaccaoModal
                    showModal={this.state.showFaccoesModal}
                    closeModal={this.closeModal}
                    carregaFavoritos={this._carregaFavoritos}
                />

                <div className='col d-flex justify-content-sm-center m-0 px-0 w-100'>
                    <span>
                        <b>Versão: </b>
                        {this.props.loadState.versaoDate}
                    </span>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = store => ({
    isLoading: store.loadingState.loading,
    pedidos: store.pedidoState,
    dataPvs: store.dataPvState,
    capacidades: store.capacidadeState.capacidades,
    loadState: store.loadState,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addPedidos,
            clearPedidos,
            addCapacidades,
            setDiasSemana,
            setPVs,
            setPVsPedidos,
            setPvAtual,
            setDiasUteis,
            setDiasUteisAtual,
            clearCurrentDataPv,
            showSuccess,
            showError,
            showLoading,
            hideLoading,
            setCurrentDataPV,
            addLoad,
            setIsHome,
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);
